import { render, staticRenderFns } from "./CreatePrivate.vue?vue&type=template&id=feb5bff6"
import script from "./CreatePrivate.vue?vue&type=script&lang=js"
export * from "./CreatePrivate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports